require('./contractEasyLoanTypeC.scss');

const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');

//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const ContractEasyLoanTypeCStep1 = require('../contractEasyLoanTypeC/contractEasyLoanTypeCStep1/contractEasyLoanTypeCStep1');
const ContractEasyLoanTypeCStep2 = require('../contractEasyLoanTypeC/contractEasyLoanTypeCStep2/contractEasyLoanTypeCStep2');
const ContractEasyLoanTypeCStep3 = require('../contractEasyLoanTypeC/contractEasyLoanTypeCStep3/contractEasyLoanTypeCStep3');
//@constants
const { FIRST_STEP } = require('constants/index');
const {
    catalogue,
    analyticsId,
    recordEasyLoanCWizardCancel,
    recordEasyLoanCWizardRequest,
    recordEasyLoanCWizardPrevious,
    recordEasyLoanCWizardFinish,
} = require("./analytics/contractEasyLoanTypeC.tracking");
//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');


class ContractEasyLoanTypeC extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.handleAcceptOutcomeModal = this.handleAcceptOutcomeModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    onCancel() {
        recordEasyLoanCWizardCancel();
        this.props.history.push('/myprofile/loans-mortgages');
    }

    builDisclaimerText(visibleStep) {
        const showSuperscriptInfo = visibleStep !== FIRST_STEP;
        if (showSuperscriptInfo) {
            return (
                <div className="contract-easy-loan-typec__superscript-info">
                    <FormattedText
                        value="contractEasyLoanTypeC-disclaimertext"
                    />
                </div>
            )
        }
    }
    handleAcceptOutcomeModal(outcome) {
        const { formHandlers } = this.props;
        formHandlers.handleOutcomeChange(outcome);
    }

    handleFinish() {
        if (__CONTACT_CENTER__) {
            recordEasyLoanCWizardFinish();
        } else {
            recordEasyLoanCWizardRequest();
        }
        this.props.onFinish();
    }

    render() {
        const {
            downloadPreContractDocument,
            getInstallment,
            immAccounts,
            immContractEasyLoan,
            immProfile,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            sendMail,
            setLoanAmount,
            setLoanTerm,
            setPurpose,
            setVisibleStep,
            setWillCancel,
            toggleAgreeCheckbox,
            toggleTypecIneAgreeCheckbox,
            validateStep,
            setLaborDetails,
            formHandlers,
            loadFileInUpload,
            clearErrorsFile,
            removeUploadedFile,
            resetUploadConfig,
            handlerEditFileName,
            loadFilesEasyLoan,
            docsUploaded,
            printIneDocumentStep2,
            sendEasyLoanSimpleEmail,
            getINEDocument,
            immContractEasyLoanInit,
            getFindOutLoanInitINEContractDocuments,
            checkReadDocument,
            requestLoanApproval,
            getPropositionNumber,
            checkStepThree
        } = this.props;

        const status = '';
        let immSteps = immContractEasyLoan.get('steps');
        const initializeInitialData = immContractEasyLoan.get('initializeInitialData');
        const stepsAmount = immSteps.size;
        const visibleStep = immContractEasyLoan.get('visibleStep');
        const disclaimerText = this.builDisclaimerText(visibleStep);
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const isFetchingStepOne = immContractEasyLoan.get('isFetchingInstallment') || immContractEasyLoan.get('isFetchingMinInstallmentQuantity') || immContractEasyLoan.get('isFetching');
        const agreeCheckboxStep1 = immContractEasyLoan.get('agreeCheckboxStep1');
        const immUpload = immContractEasyLoan.get("upload");
        const agreeTypeCINECheckbox = immContractEasyLoan.get('agreeTypeCINECheckbox');

        const isFetchingStepThree =
            immUpload.get("isFetching") ||
            immUpload.get("isFetchingDocumentsConfirm") ||
            immUpload.get("isLoadingFiles");

        const actions = {
            cancel: this.onCancel,
            finish: this.handleFinish,
            resetStep: () => false,
            setVisibleStep,
            setWillCancel,
            validateStep,
            previousClick: recordEasyLoanCWizardPrevious,
        };
        let stepOne = <LoadingSection />;
        if (immContractEasyLoan.get('stepReady') && initializeInitialData) {
            stepOne = (
                <ContractEasyLoanTypeCStep1
                    setPurpose={setPurpose}
                    getInstallment={getInstallment}
                    immContractEasyLoan={immContractEasyLoan}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    downloadPreContractDocument={downloadPreContractDocument}
                    requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                    showTooltip
                    setLaborDetails={setLaborDetails}
                    onAccept={this.handleAcceptOutcomeModal}
                    formHandlers={formHandlers}
                    toggleAgreeCheckbox={toggleAgreeCheckbox}
                />
            );
        }

        const tealiumData = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW](),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]({
                data: immContractEasyLoan.get("minTae"),
            }),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_3_VIEW]({
                data: immContractEasyLoan.get("minTae"),
            }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS](),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS](),
        ];

        const isCCEnv = __CONTACT_CENTER__ && !isPrintOfficeMode()
        return (
            <React.Fragment>
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    wizardClass={visibleStep === 2 ? "contract-easy-loan-typec__wizard disable-previous-button-from-step" : "contract-easy-loan-typec__wizard"}
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={{
                        next: tealiumEvents[visibleStep - 1],
                    }}
                    isTaggingSecondVersion
                >
                    <WizardStep
                        cancelButton
                        isLoading={isFetchingStepOne}
                        nextButtonDisabled={!agreeCheckboxStep1}
                        nextButton
                        position="first"
                    >
                        {stepOne}
                    </WizardStep>

                    <WizardStep
                        position="middle"
                        nextButton
                        cancelButton
                        nextButtonDisabled={isPrintOfficeMode() ? !immContractEasyLoan.get("officePrintStepTwo") : !agreeTypeCINECheckbox}
                    >
                        <ContractEasyLoanTypeCStep2
                            immAccounts={immAccounts}
                            checkReadDocument={checkReadDocument}
                            getFindOutLoanInitINEContractDocuments={getFindOutLoanInitINEContractDocuments}
                            immContractEasyLoan={immContractEasyLoan}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendMail={sendMail}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            toggleTypecIneAgreeCheckbox={toggleTypecIneAgreeCheckbox}
                            printIneDocumentStep2={printIneDocumentStep2}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            getINEDocument={getINEDocument}
                            immContractEasyLoanInit={immContractEasyLoanInit}
                            requestLoanApproval={requestLoanApproval}
                            getPropositionNumber={getPropositionNumber}
                        />
                    </WizardStep>
                    <WizardStep
                        cancelButton
                        finishButton
                        officeSignature={isPrintOfficeMode()}
                        finalButtonDisabled={!(isCCEnv || docsUploaded())}
                        immFinalButton={`easyLoanTypeCRequestStepThree-${isCCEnv ? 'callToActionButtonCC' : 'callToActionButton'}`}
                        isLoading={isFetchingStepThree}
                        position="last"
                        previousButton
                    >
                        <ContractEasyLoanTypeCStep3
                            clearErrorsFile={clearErrorsFile}
                            removeUploadedFile={removeUploadedFile}
                            loadFileInUpload={loadFileInUpload}
                            immContractEasyLoan={immContractEasyLoan}
                            recordStatus={status}
                            resetUploadConfig={resetUploadConfig}
                            handlerEditFileName={handlerEditFileName}
                            loadFilesEasyLoan={loadFilesEasyLoan}
                            checkStepThree={checkStepThree}
                        />
                    </WizardStep>

                </Wizard>
                {disclaimerText}
            </React.Fragment>
        );
    }
}

ContractEasyLoanTypeC.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleTypecIneAgreeCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    setLaborDetails: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    loadFileInUpload: PropTypes.object.isRequired,
    clearErrorsFile: PropTypes.object.isRequired,
    removeUploadedFile: PropTypes.object.isRequired,
    resetUploadConfig: PropTypes.object.isRequired,
    handlerEditFileName: PropTypes.object.isRequired,
    loadFilesEasyLoan: PropTypes.object.isRequired,
    docsUploaded: PropTypes.object.isRequired,
    printIneDocumentStep2: PropTypes.func.isRequired,
    sendEasyLoanSimpleEmail: PropTypes.func.isRequired,
    immContractEasyLoanInit: PropTypes.object,
};

module.exports = withRouter(ContractEasyLoanTypeC);
